import {
  SET_FILTER,
  SET_MATCHES,
  SET_PAGING,
} from 'reduxes/slices/paging/actions'

import {
  mergeArraysWithoutDuplicates,
  removeItemFromArray,
} from '../../util/reducers'
import { SET_DESTROYED } from '../api/actions'
import { INITIAL_PAGING_STATE, SET_TIMELINES_PAGING } from './actions'

export const BASE_PAGING_STATE = {
  group_chats: INITIAL_PAGING_STATE,
  live_chats: INITIAL_PAGING_STATE,
  contacts: {
    matches: undefined,
    hasMore: undefined,
  },
  timelines: {},
  search: {
    filter: {
      search_term: '',
    },
  },
}

export function paging(state = BASE_PAGING_STATE, action) {
  if (action.type === SET_PAGING) {
    const { keys, pagingState } = action
    Object.keys(pagingState).forEach((key) => {
      pagingState[key] === undefined && delete pagingState[key]
    })
    return updateNestedObjectDynamically(state, keys, pagingState)
  }

  switch (action.type) {
    case SET_FILTER:
      if (action.key === 'search') {
        return setSearchFilter(state, action)
      } else {
        return setFilter(state, action)
      }
    case SET_MATCHES:
      if (action.key === 'search') {
        return setSearchMatches(state, action)
      } else {
        return setMatches(state, action)
      }
    case SET_TIMELINES_PAGING:
      Object.keys(action.newState).forEach((key) => {
        action.newState[key] === undefined && delete action.newState[key]
      })
      return {
        ...state,
        timelines: {
          ...state.timelines,
          [action.topicId]: {
            ...state.timelines[action.topicId],
            ...action.newState,
          },
        },
      }
    case SET_DESTROYED:
      if (action.modelName === 'topics') {
        const currentMatches = getMatches(state, 'group_chats')
        const indexToRemove = currentMatches.indexOf(action.id)
        return {
          ...state,
          matches: removeItemFromArray(currentMatches, indexToRemove),
        }
      }
      return state
    default:
      return state
  }
}

const setFilter = (state, action) => {
  const { key, filter } = action
  return {
    ...state,
    [key]: {
      ...state[key],
      filter: {
        ...state[key].filter,
        ...filter,
      },
      matches: undefined,
      hasMore: undefined,
    },
  }
}

const setSearchFilter = (state, action) => {
  const { key, filter } = action
  return {
    ...state,
    [key]: {
      ...state[key],
      filter: {
        ...state[key].filter,
        ...filter,
      },
    },
  }
}

function setMatches(state, action) {
  const { key, matches, hasMore, replaceState } = action
  const existingMatches = replaceState ? [] : getMatches(state, key)

  const obj = {
    matches: mergeArraysWithoutDuplicates(existingMatches, matches),
    hasMore,
  }
  return {
    ...state,
    [key]: {
      ...state[key],
      ...obj,
    },
  }
}

function updateNestedObjectDynamically(state, keys, obj) {
  const key = keys.shift()
  if (keys.length) {
    return {
      ...state,
      [key]: updateNestedObjectDynamically(state[key], keys, obj),
    }
  } else {
    return {
      ...state,
      [key]: {
        ...state[key],
        ...obj,
      },
    }
  }
}

function getMatches(state, key) {
  return state?.[key]?.matches || []
}

function setSearchMatches(state, action) {
  let newState = state
  const { key, matches, replaceState } = action
  Object.keys(matches).forEach((model) => {
    const existingMatches = replaceState ? [] : state[key][model]?.matches || []

    newState = {
      ...newState,
      [key]: {
        ...newState[key],
        [model]: {
          ...newState[key][model],
          matches: mergeArraysWithoutDuplicates(
            existingMatches,
            matches[model],
          ),
          prevFetchCount: matches[model].length,
        },
      },
    }
  })
  return newState
}

// const paging = {
//   search: {
//     filter: {
//       search_term: '',
//       items: {
//         sort: 'most relevant'
//       },
//       files: {
//         file_type: 'images'
//       }
//     },
//     matches: {
//       items: [],
//       files: []
//     },
//     prevFetchCount: {
//       items: undefined,
//       files: undefined
//     }
//   }
// }
//
// const paging = {
//   search: {
//     filter: {
//       search_term: ''
//     },
//     chat_timelines: {
//       filter: {
//         sort: 'most relevant'
//       },
//       matches: [],
//       prevFetchCount: undefined
//     }
//   }
// }
